import { defineComponent as _defineComponent } from 'vue'
import WalletsDashboardWidget from 'ah-wallets/src/components/WalletsDashboardWidget.vue';
import NotificationsDashboardWidget from '@/app/components/notifications/NotificationsDashboardWidget.vue';
import OpenPositionsDashboardWidget from '@/app/components/trades/widgets/OpenPositionsDashboardWidget.vue';
import CollateralStatusDashboardWidget from 'ah-trades/src/components/collaterals/CollateralStatusDashboardWidget.vue';
import LimitsAndCollateralDashboardWidget from 'ah-trades/src/components/limitsAndCollateral/LimitsAndCollateralDashboardWidget.vue';
// import LimitsDashboardWidget from 'ah-trades/src/components/collaterals/LimitsDashboardWidget.vue';
import PaymentsDashboardWidget from '@/app/components/payments/PaymentsDashboardWidget.vue';
import { AuthorityType } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authStore';
import { FeatureFlag } from 'ah-api-gateways';
import { useFeatureFlag } from 'ah-common-stores/src/stores/featureFlagStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardView',
  setup(__props) {

const authStore = useAuthStore();

const { isActive: isVariationMarginFeatureActive } = useFeatureFlag({
  featureFlag: FeatureFlag.VARIATION_MARGIN_AND_LIMITS_FEATURE,
});

function canViewTrades() {
  authStore.hasAuthorities(AuthorityType.VIEW_TRADES);
}

return { __sfc: true,authStore, isVariationMarginFeatureActive, canViewTrades, WalletsDashboardWidget, NotificationsDashboardWidget, OpenPositionsDashboardWidget, CollateralStatusDashboardWidget, LimitsAndCollateralDashboardWidget, PaymentsDashboardWidget }
}

})